import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Breadcrumb from '../../../../shared/breadcrumb/Breadcrumb';
import Items from './Items';
import { Tabs } from '../../../../components';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedTab: 0,
    };
  }

  changeSelectedTab = (/* { index } */) => {
    // this.setState({ selectedTab: index });
  };

  render() {
    const { match } = this.props;
    return (
      <div>
        {match.url !== 'trade/admin/uniformes/editar/834' && (
          <div>
            <Breadcrumb crumb="Uniformes" description="Gerencie os pedidos de uniformes." />

            <section className="content-wrapper">
              <Tabs
                sections={[
                  { title: 'Todos', path: `${match.url}/todos` },
                  { title: 'Pendente', path: `${match.url}/pendentes` },
                  { title: 'Preparação', path: `${match.url}/preparacao` },
                  { title: 'Pronto p/ Entrega', path: `${match.url}/prontos` },
                  { title: 'Entregue', path: `${match.url}/entregue` },
                  { title: 'Aguardando Devolução', path: `${match.url}/aguardando-devolucao` },
                  { title: 'Devolvido', path: `${match.url}/devolvido` },
                  { title: 'Cancelado', path: `${match.url}/cancelado` },
                ]}
              />
              <Route
                path={`${match.url}/todos`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido=&AguardandoDevolucao="
                  />
                )}
              />
              <Route
                path={`${match.url}/pendentes`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=true&preparacao=&prontoEntrega=&entregue=&devolvido=&AguardandoDevolucao="
                    showCheck
                  />
                )}
              />
              <Route
                path={`${match.url}/preparacao`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=&preparacao=true&prontoEntrega=true&entregue=&devolvido=&AguardandoDevolucao="
                    showCheck
                  />
                )}
              />
              <Route
                path={`${match.url}/prontos`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=&preparacao=&prontoEntrega=true&entregue=&devolvido=&AguardandoDevolucao="
                    showCheck
                  />
                )}
              />
              <Route
                path={`${match.url}/entregue`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=true&devolvido=&AguardandoDevolucao="
                    showCheck
                  />
                )}
              />
              <Route
                path={`${match.url}/devolvido`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido=true&AguardandoDevolucao="
                  />
                )}
              />
              <Route
                path={`${match.url}/cancelado`}
                component={props => (
                  <Items
                    {...props}
                    defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido=&cancelado=true&AguardandoDevolucao="
                  />
                )}
              />
              <Route
                path={`${match.url}/aguardando-devolucao`}
                component={props => (
                  <Items
                    {...props}
                    showCheck
                    defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido=&cancelado=&AguardandoDevolucao=true"
                  />
                )}
              />              
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Uniforms/List.js